<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Alterar dados GarantePay</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Dados GarantePay</a>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>Alterar</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header"><span><v-icon size="20">mdi-domain</v-icon></span><div><h4>Alterar dados GarantePay</h4><p>Configure os dados institucionais, fiscais e de serviços.</p></div></div>
                            <div class="card-body">
                                <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                    <v-tab value="dados" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Dados GarantePay</v-tab>
                                    <div>
                                        <v-tab value="nota" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Dados Nota</v-tab>
                                    </div>
                                    <div>
                                        <v-tab value="notaservico" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Dados Serviços</v-tab>
                                    </div>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <section class="gp-detail-block gp-company-block">
                                            <div class="gp-detail-block-header"><span class="gp-detail-block-icon"><v-icon size="18">mdi-domain</v-icon></span><div><h4>Dados da GarantePay</h4><p>Informações cadastrais, responsável e contatos.</p></div></div>
                                            <div class="gp-detail-block-body">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="GarantePay.gpyId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nº CNPJ</label>
                                                            <input v-model="GarantePay.gpyDocumento" type="text" v-mask="documentoMask"
                                                                class="form-control" placeholder="CNPJ" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-8 col-lg-8">
                                                        <div class="form-group">
                                                            <label>Razão Social</label>
                                                            <input v-model="GarantePay.gpyRazaoSocial" type="text"
                                                                class="form-control" placeholder="Razão Social" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome</label>
                                                            <input v-model="GarantePay.gpyNomeEmpresa" type="text"
                                                                class="form-control" placeholder="Nome Fantasia" />
                                                        </div>
                                                    </div>
                                                 
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome Responsável</label>
                                                            <input v-model="GarantePay.gpyResponsavel" type="text"
                                                                class="form-control" placeholder="Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CPF Responsável</label>
                                                            <input v-model="GarantePay.gpyCpfResponsavel" type="text" v-mask="'###.###.###-##'"
                                                                class="form-control" placeholder="CPF Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Telefone</label>
                                                            <input v-model="GarantePay.gpyTelefone" v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Whatsapp</label>
                                                            <input v-model="GarantePay.gpyWhatsapp" v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>E-mail</label>
                                                            <input v-model="GarantePay.gpyEmail" type="text" class="form-control" placeholder="E-mail" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                            </div>
                                        </section>
                                    </v-window-item>
                                    <!--endereço-->
                                    <div v-show="tab === 'dados'" v-if="GarantePay!=''">
                                        <section class="gp-detail-block gp-address-block">
                                            <div class="gp-detail-block-header"><span class="gp-detail-block-icon gp-address-icon"><v-icon size="18">mdi-map-marker-outline</v-icon></span><div><h4>Endereço</h4><p>Localização e dados de correspondência.</p></div></div>
                                            <div class="gp-detail-block-body">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>CEP</label>
                                                            <input v-model="GarantePay.gpyCep" v-mask="'#####-###'" type="text"
                                                                class="form-control" placeholder="CEP" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Endereço</label>
                                                            <input v-model="GarantePay.gpyEndereco" type="text"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Número</label>
                                                            <input v-model="GarantePay.gpyNumero" type="number"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Complemento</label>
                                                            <input v-model="GarantePay.gpyComplemento" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Estado</label>
                                                            <input v-model="GarantePay.gpyEstado" type="text"
                                                                class="form-control" placeholder="Estado" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Cidade</label>
                                                            <input v-model="GarantePay.gpyCidade" type="text"
                                                                class="form-control" placeholder="Cidade" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Bairro</label>
                                                            <input v-model="GarantePay.gpyBairro" type="text"
                                                                class="form-control" placeholder="Bairro" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                            </div>
                                        </section>
                                    </div>
                                    <!--endereco-->
                                     <!--nota-->
                                     <v-window-item value="nota" v-if="GarantePayNota!=''">
                                        <v-form>
                                            <v-container>
                                                <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="GarantePayNota.gpnId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Enviar E-mail Tomador</label>
                                                            <select  v-model="GarantePayNota.gpnEnviarEmail" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Incentivador Cultural</label>
                                                            <select  v-model="GarantePayNota.gpnIncentivadorCultural" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Incentivo Fiscal</label>
                                                            <select  v-model="GarantePayNota.gpnIncentivoFiscal" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Simples Nacional</label>
                                                            <select  v-model="GarantePayNota.gpnSimplesNacional" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Inscrição Estadual</label>
                                                            <input v-model="GarantePayNota.gpnInscricaoEstadual" type="text"
                                                                class="form-control" placeholder="Inscrição Estadual" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Inscrição Municipal</label>
                                                            <input v-model="GarantePayNota.gpnInscricaoMunicipal" type="text"
                                                                class="form-control" placeholder="Inscrição Municipal" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Regime Tributário</label>
                                                            <select  v-model="GarantePayNota.gpnRegimeTributario" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListRegimeTributario" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Regime Tributário Especial</label>
                                                            <select  v-model="GarantePayNota.gpnRegimeTributarioEspecial" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListRegimeTributarioEspecial" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                  
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Cod. Distrito (IBGE)</label>
                                                            <input v-model="GarantePayNota.gpnCodigoDistrito" type="number"
                                                                class="form-control" placeholder="Cod. Distrito" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-9 col-lg-9">
                                                        <div class="form-group">
                                                            <label>Token PlugNotas</label>
                                                            <input v-model="GarantePayNota.gpnToken" type="text"
                                                                class="form-control" placeholder="Token PlugNotas" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--nota-->
                                    <!--Serviços da nota-->
                                    <v-window-item value="notaservico" v-if="GarantePay.gpyId!=0">
                                            <v-form>
                                                <v-container>
                                                    <div class="row">
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Cod. Serviço GarantePay</label>
                                                            <input v-model="NotaServico.gnsCodigoServicoGarantePay" type="number" class="form-control"
                                                                placeholder="Cód. Serviço" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 col-lg-6">
                                                            <div class="form-group">
                                                            <label>Nome Serviço</label>
                                                            <input v-model="NotaServico.gnsNomeServicoGarantePay" type="text" class="form-control"
                                                                placeholder="Nome Serviço" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Serviço Fiscal</label>
                                                            <input v-model="NotaServico.gnsCodServicoFiscal" type="text" class="form-control"
                                                                placeholder="999999" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação</label>
                                                            <input v-model="NotaServico.gnsCodTributacao" type="text" class="form-control"
                                                                placeholder="99.99" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 col-lg-4">
                                                            <div class="form-group">
                                                                <label>ISS Tipo Tributação</label>
                                                                <select  v-model="NotaServico.gnsIssTipoTributacao" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListTipoTributacao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>ISS Exigibilidade</label>
                                                                <select  v-model="NotaServico.gnsIssExigibilidade" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListExigibilidade" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                             <div class="form-group">
                                                                <label>Iss Retido</label>
                                                                <select  v-model="NotaServico.gnsIssRetido" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                            <label>Cnae</label>
                                                            <input v-model="NotaServico.gnsCnae" type="text" class="form-control"
                                                                placeholder="Cnae" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>ISS Aliquota</label>
                                                                <input v-model="NotaServico.gnsAliquota" v-decimal class="form-control"
                                                                    placeholder="Aliquota" />
                                                                </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>PIS Aliquota</label>
                                                            <input v-model="NotaServico.gnsPisAliquota" v-decimal class="form-control"
                                                                placeholder="" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>COFINS Aliquota</label>
                                                            <input v-model="NotaServico.gnsCofinsAliquota" v-decimal class="form-control"
                                                                placeholder="" />
                                                            </div>
                                                        </div>
                                                          <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>CSLL Aliquota</label>
                                                            <input v-model="NotaServico.gnsCsllAliquota" v-decimal class="form-control"
                                                                placeholder="CSLL Aliquota" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>INSS Aliquota</label>
                                                            <input v-model="NotaServico.gnsInssAliquota" v-decimal class="form-control"
                                                                placeholder="INSS Aliquota" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>IRRF Aliquota</label>
                                                            <input v-model="NotaServico.gnsIrrfAliquota" v-decimal class="form-control"
                                                                placeholder="IRRF Aliquota" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Outras Retenções</label>
                                                            <input v-model="NotaServico.gnsOutrasRetencoes" v-decimal class="form-control"
                                                                placeholder="Outras Retenções" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>CPP Aliquota</label>
                                                            <input v-model="NotaServico.gnsCppAliquota" v-decimal class="form-control"
                                                                placeholder="Outras Retenções" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação Federal %</label>
                                                            <input v-model="NotaServico.gnsTributacaoTotalFederal" v-decimal class="form-control"
                                                                placeholder="Tributação Federal %<" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação Estadual %</label>
                                                            <input v-model="NotaServico.gnsTributacaoTotalEstadual" v-decimal class="form-control"
                                                                placeholder="Tributação Estadual %<" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação Municipal %</label>
                                                            <input v-model="NotaServico.gnsTributacaoTotalMunicipal" v-decimal class="form-control"
                                                                placeholder="Tributação Municipal %<" />
                                                            </div>
                                                        </div>

                                                        <div class="col-md-3 col-lg-3">
                                                            <button v-if="NotaServico.gnsId == 0"
                                                                type="button" class="btn btn-info"
                                                                @click.prevent="AddNotaServicos()"
                                                                style="color:#ffffff;margin-top: 40px;">
                                                                Inserir
                                                            </button>
                                                            <button v-else
                                                                type="button" class="btn btn-info"
                                                                @click.prevent="PutNotaServicos()"
                                                                style="color:#ffffff;margin-top: 40px;">
                                                                Alterar
                                                            </button>
                                                            <a href="#" @click="EditCancel()" style="margin-top: 40px;" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                    <div class="row" style="padding-top: 20px;">
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Cod
                                                                    </th>
                                                                    <th class="text-left">
                                                                       Serviço
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cód. Fiscal
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Tributação
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cnae
                                                                    </th>
                                                                    <th class="text-left">
                                                                        ISS Tipo Tributação
                                                                    </th>
                                                                    <th class="text-left">
                                                                        ISS Exigibilidade
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Iss Retido
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Aliquota
                                                                    </th>
                                                                    <th colspan="2">
                                                                        Ações
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody v-if="ListTipoTributacao!=''">
                                                                <tr v-for="item in GarantePayNotaServico" :key="item.gnsId">
                                                                    <td>{{ item.gnsCodigoServicoGarantePay }}</td>
                                                                    <td>{{ item.gnsNomeServicoGarantePay }}</td>
                                                                    <td>{{ item.gnsCodServicoFiscal }}</td>
                                                                    <td>{{ item.gnsCodTributacao }}</td>
                                                                    <td>{{ item.gnsCnae }}</td>
                                                                    <td>{{ ListTipoTributacao.filter(x=> x.Id == item.gnsIssTipoTributacao)[0].Nome }}</td>
                                                                    <td>{{ ListExigibilidade.filter(x=> x.Id == item.gnsIssExigibilidade)[0].Nome }}</td>
                                                                    <td>{{ item.gnsIssRetido ? 'Sim' : 'Não' }}</td>
                                                                    <td>{{ item.gnsAliquota }}</td>
                                                                    <td colspan="2" style="text-align: center;">
                                                                        <div class="gp-table-actions">
                                                                            <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click.prevent="EditarServico(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
                                                                            <button type="button" class="gp-table-action gp-action-delete" title="Excluir" @click.prevent="DeleteServico(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                </v-container>
                                            </v-form>
                                      </v-window-item>
                                    <!--Serviços da nota-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button type="button" class="btn btn-success" style="color:#ffffff;"  @click="Put()">
                            Alterar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'
import { intAt } from 'jsencrypt/lib/lib/jsbn/jsbn';

export default {
    name: 'GarantePayView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        User:[],
        editor: DecoupledEditor,
        tab: 'dados',
        NomeTela:'Garantidoras',
        InfoTela:'Lista de garantidoras',
        GarantePay:[],    
        GarantePayNota:[],
        GarantePayNotaServico:[],
        NotaServico:{
            gnsId: 0,
            gnsCodigoServicoGarantePay: '',
            gnsNomeServicoGarantePay: '',
            gnsCodServicoFiscal: '',
            gnsCodTributacao: '',
            gnsCnae: '',
            gnsIssTipoTributacao: null,
            gnsIssExigibilidade: null,
            gnsIssRetido: null,
            gnsAliquota: '',
            gpyId: '',
            gnsPisAliquota: null,
            gnsCofinsAliquota: null,
            gnsCsllAliquota: null,
            gnsInssAliquota: null,
            gnsIrrfAliquota: null,
            gnsOutrasRetencoes: null, 
            gnsCppAliquota: null,
            gnsTributacaoTotalFederal: null,
            gnsTributacaoTotalEstadual: null,
            gnsTributacaoTotalMunicipal: null,
        },
        ListSimNao: [{Id: true, Nome: 'Sim'},{Id: false, Nome: 'Não'}],
        ListRegimeTributario:[
        {Id: 0, Nome: 'Nenhum'},
        {Id: 1, Nome: 'Simples Nacional'},
        {Id: 2, Nome: 'Simples Nacional - Excesso'},
        {Id: 3, Nome: 'Regime Normal - Lucro Presumido'},
        {Id: 4, Nome: 'Normal - Lucro Real'},
        {Id: 5, Nome: 'MEI (Microempreendedor individual)'},
        ],
        ListRegimeTributarioEspecial: [
        { Id: 0, Nome: 'Sem Regime Tributário Especial' },
        { Id: 1, Nome: 'Micro Empresa Municipal' },
        { Id: 2, Nome: 'Estimativa' },
        { Id: 3, Nome: 'Sociedade de Profissionais' },
        { Id: 4, Nome: 'Cooperativa' },
        { Id: 5, Nome: 'Microempresário Individual - MEI' },
        { Id: 6, Nome: 'Microempresa ou Pequeno Porte - ME EPP' },
        { Id: 7, Nome: 'Lucro Real' },
        { Id: 8, Nome: 'Lucro Presumido' },
        { Id: 9, Nome: 'Tributação Normal' },
        { Id: 10, Nome: 'Simples nacional com excesso do sublimite' },
        { Id: 11, Nome: 'Empresa de Responsabilidade Limitada' }
        ],
        ListTipoTributacao: [
        { Id: 0, Nome: 'Não definido' },
        { Id: 1, Nome: 'Isento de ISS' },
        { Id: 2, Nome: 'Imune' },
        { Id: 3, Nome: 'Não Incidência no Município' },
        { Id: 4, Nome: 'Não Tributável' },
        { Id: 5, Nome: 'Retido' },
        { Id: 6, Nome: 'Tributável Dentro do Município' },
        { Id: 7, Nome: 'Tributável Fora do Município' },
        { Id: 8, Nome: 'Tributável Dentro do Município pelo tomador' }
        ],
        ListExigibilidade: [
        { Id: 1, Nome: 'Exigível' },
        { Id: 2, Nome: 'Não Incidência' },
        { Id: 3, Nome: 'Isenção' },
        { Id: 4, Nome: 'Exportação' },
        { Id: 5, Nome: 'Imunidade' },
        { Id: 6, Nome: 'Supenso por Ação Judicial' },
        { Id: 7, Nome: 'Suspenso por Ação Administrativa' },
        ]
    }),
    methods: {
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditCancel(){
            //window.location.reload();
            this.$router.go(0);
        },
        async Put() {
            // Converte gpyNumero para string, se aplicável
            if (this.GarantePay.gpyNumero !== '' && this.GarantePay.gpyNumero !== null) {
                this.GarantePay.gpyNumero = String(this.GarantePay.gpyNumero);
            }

            // Converte gpnCodigoDistrito para inteiro, se aplicável
            if (this.GarantePayNota.gpnCodigoDistrito !== '' && this.GarantePayNota.gpnCodigoDistrito !== null) {
                this.GarantePayNota.gpnCodigoDistrito = parseInt(this.GarantePayNota.gpnCodigoDistrito);
            }
            
            // Atribui o id do GarantePay para o objeto Nota
            this.GarantePayNota.gpyId = this.GarantePay.gpyId;

            try {
                const [res1, res2] = await Promise.all([
                axios.put(`/Telas/GarantePay/Update`, this.GarantePay),
                axios.put(`/Telas/GarantePay/UpdateNota`, this.GarantePayNota)
                ]);

                if (res1.status === 200 && res2.status === 200) {
                this.$mensagemAvisoSucesso("Registro Atualizado.");
                this.Get();
                }
            } catch (error) {
                // Aqui você pode tratar os erros conforme necessário
                console.error(error);
            }
            },
        async AddNotaServicos(){
            if (this.NotaServico.gnsCodigoServicoGarantePay == null || this.NotaServico.gnsCodigoServicoGarantePay === '') {
               this.$mensagemAviso("Código do serviço GarantePay obrigatório.");
            } 
            else if (this.NotaServico.gnsNomeServicoGarantePay == null || this.NotaServico.gnsNomeServicoGarantePay === ''){
                this.$mensagemAviso("Nome do serviço GarantePay obrigatório.");
            }
            else if (this.NotaServico.gnsCodServicoFiscal == null || this.NotaServico.gnsCodServicoFiscal === ''){
                this.$mensagemAviso("Serviço Fiscal obrigatório.");
            }
            else if (this.NotaServico.gnsCodTributacao == null || this.NotaServico.gnsCodTributacao === ''){
                this.$mensagemAviso("Tributação obrigatório.");
            }
            else if (this.NotaServico.gnsCnae == null || this.NotaServico.gnsCnae === ''){
                this.$mensagemAviso("Cnae obrigatório.");
            }
            else if (this.NotaServico.gnsIssTipoTributacao == null || this.NotaServico.gnsIssTipoTributacao === ''){
                this.$mensagemAviso("Iss Tipo Tributação obrigatório.");
            }
            else if (this.NotaServico.gnsIssExigibilidade == null || this.NotaServico.gnsIssExigibilidade === ''){
                this.$mensagemAviso("Iss Exigibilidade obrigatório.");
            }
            else if (this.NotaServico.gnsIssRetido == null || this.NotaServico.gnsIssRetido === ''){
                this.$mensagemAviso("Iss Retido obrigatório.");
            }
            else if (this.NotaServico.gnsAliquota == null || this.NotaServico.gnsAliquota === ''){
                this.$mensagemAviso("Aliquota obrigatório.");
            }
            else {
            // Continuação do processamento
            this.NotaServico.gpyId = this.GarantePay.gpyId;
            this.NotaServico.gnsCodigoServicoGarantePay = parseInt(this.NotaServico.gnsCodigoServicoGarantePay, 10);
            this.NotaServico.gnsAliquota = this.NotaServico.gnsAliquota != null ? parseFloat(String(this.NotaServico.gnsAliquota).replaceAll(',','.')) : null;
            this.NotaServico.gnsPisAliquota = this.NotaServico.gnsPisAliquota != null ?parseFloat(String(this.NotaServico.gnsPisAliquota).replaceAll(',','.')) : null;
            this.NotaServico.gnsCofinsAliquota = this.NotaServico.gnsCofinsAliquota != null ?parseFloat(String(this.NotaServico.gnsCofinsAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsCsllAliquota = this.NotaServico.gnsCsllAliquota != null ?parseFloat(String(this.NotaServico.gnsCsllAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsInssAliquota = this.NotaServico.gnsInssAliquota != null ?parseFloat(String(this.NotaServico.gnsInssAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsIrrfAliquota = this.NotaServico.gnsIrrfAliquota != null ?parseFloat(String(this.NotaServico.gnsIrrfAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsOutrasRetencoes = this.NotaServico.gnsOutrasRetencoes != null ?parseFloat(String(this.NotaServico.gnsOutrasRetencoes).replaceAll(',','.')): null;
            this.NotaServico.gnsCppAliquota = this.NotaServico.gnsCppAliquota != null ?parseFloat(String(this.NotaServico.gnsCppAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsTributacaoTotalFederal = String(this.NotaServico.gnsTributacaoTotalFederal).replaceAll(',','.');
            this.NotaServico.gnsTributacaoTotalEstadual = String(this.NotaServico.gnsTributacaoTotalEstadual).replaceAll(',','.');
            this.NotaServico.gnsTributacaoTotalMunicipal = String(this.NotaServico.gnsTributacaoTotalMunicipal).replaceAll(',','.');
            this.NotaServico.gnsCnae =  this.NotaServico.gnsCnae.replaceAll('-','').replaceAll('.','')

           await axios.post(`/Telas/GarantePay/AddNotaServicos`, this.NotaServico)
                .then(response => {
                if (response.data > 0) {
                    this.NotaServico.gnsId = response.data;
                    this.$mensagemAvisoSucesso("Serviço Incluído")
                    this.NotaServico.gnsId= 0;
                    this.NotaServico.gnsCodigoServicoGarantePay = '';
                    this.NotaServico.gnsNomeServicoGarantePay = '';
                    this.NotaServico.gnsCodServicoFiscal = '';
                    this.NotaServico.gnsCodTributacao = '';
                    this.NotaServico.gnsCnae = '';
                    this.NotaServico.gnsIssTipoTributacao = null;
                    this.NotaServico.gnsIssExigibilidade = null;
                    this.NotaServico.gnsIssRetido = null;
                    this.NotaServico.gnsAliquota = '';
                    this.NotaServico.gnsPisAliquota = null;
                    this.NotaServico.gnsCofinsAliquota = null;
                    this.NotaServico.gnsCsllAliquota = null;
                    this.NotaServico.gnsInssAliquota = null;
                    this.NotaServico.gnsIrrfAliquota = null;
                    this.NotaServico.gnsOutrasRetencoes = null;
                    this.NotaServico.gnsCppAliquota = null;
                    this.NotaServico.gnsTributacaoTotalFederal = null;
                    this.NotaServico.gnsTributacaoTotalEstadual = null;
                    this.NotaServico.gnsTributacaoTotalMunicipal = null;

                    axios.get(`/Telas/GarantePay/GetAllNotaServicos`)
                    .then(response => {
                        this.GarantePayNotaServico = response.data;
                    });    
                }
            });
            }
        },
        EditarServico(value){
            value.gnsAliquota = value.gnsAliquota.toString().replaceAll('.',',')
            this.NotaServico = value;
        },
        PutNotaServicos(){
            if (this.NotaServico.gnsCodigoServicoGarantePay == null || this.NotaServico.gnsCodigoServicoGarantePay === '') {
               this.$mensagemAviso("Código do serviço GarantePay obrigatório.");
            } 
            else if (this.NotaServico.gnsNomeServicoGarantePay == null || this.NotaServico.gnsNomeServicoGarantePay === ''){
                this.$mensagemAviso("Nome do serviço GarantePay obrigatório.");
            }
            else if (this.NotaServico.gnsCodServicoFiscal == null || this.NotaServico.gnsCodServicoFiscal === ''){
                this.$mensagemAviso("Serviço Fiscal obrigatório.");
            }
            else if (this.NotaServico.gnsCodTributacao == null || this.NotaServico.gnsCodTributacao === ''){
                this.$mensagemAviso("Tributação obrigatório.");
            }
            else if (this.NotaServico.gnsCnae == null || this.NotaServico.gnsCnae === ''){
                this.$mensagemAviso("Cnae obrigatório.");
            }
            else if (this.NotaServico.gnsIssTipoTributacao == null || this.NotaServico.gnsIssTipoTributacao === ''){
                this.$mensagemAviso("Iss Tipo Tributação obrigatório.");
            }
            else if (this.NotaServico.gnsIssExigibilidade == null || this.NotaServico.gnsIssExigibilidade === ''){
                this.$mensagemAviso("Iss Exigibilidade obrigatório.");
            }
            else if (this.NotaServico.gnsIssRetido == null || this.NotaServico.gnsIssRetido === ''){
                this.$mensagemAviso("Iss Retido obrigatório.");
            }
            else if (this.NotaServico.gnsAliquota == null || this.NotaServico.gnsAliquota === ''){
                this.$mensagemAviso("Aliquota obrigatório.");
            }
            else {
            // Continuação do processamento
            this.NotaServico.gpyId = this.GarantePay.gpyId;
            this.NotaServico.gnsCodigoServicoGarantePay = parseInt(this.NotaServico.gnsCodigoServicoGarantePay, 10);
            this.NotaServico.gnsAliquota = this.NotaServico.gnsAliquota != null ? parseFloat(String(this.NotaServico.gnsAliquota).replaceAll(',','.')) : null;
            this.NotaServico.gnsPisAliquota = this.NotaServico.gnsPisAliquota != null ?parseFloat(String(this.NotaServico.gnsPisAliquota).replaceAll(',','.')) : null;
            this.NotaServico.gnsCofinsAliquota = this.NotaServico.gnsCofinsAliquota != null ?parseFloat(String(this.NotaServico.gnsCofinsAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsCsllAliquota = this.NotaServico.gnsCsllAliquota != null ?parseFloat(String(this.NotaServico.gnsCsllAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsInssAliquota = this.NotaServico.gnsInssAliquota != null ?parseFloat(String(this.NotaServico.gnsInssAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsIrrfAliquota = this.NotaServico.gnsIrrfAliquota != null ?parseFloat(String(this.NotaServico.gnsIrrfAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsOutrasRetencoes = this.NotaServico.gnsOutrasRetencoes != null ?parseFloat(String(this.NotaServico.gnsOutrasRetencoes).replaceAll(',','.')): null;
            this.NotaServico.gnsCppAliquota = this.NotaServico.gnsCppAliquota != null ?parseFloat(String(this.NotaServico.gnsCppAliquota).replaceAll(',','.')): null;
            this.NotaServico.gnsTributacaoTotalFederal = String(this.NotaServico.gnsTributacaoTotalFederal).replaceAll(',','.');
            this.NotaServico.gnsTributacaoTotalEstadual = String(this.NotaServico.gnsTributacaoTotalEstadual).replaceAll(',','.');
            this.NotaServico.gnsTributacaoTotalMunicipal = String(this.NotaServico.gnsTributacaoTotalMunicipal).replaceAll(',','.');
            this.NotaServico.gnsCnae =  this.NotaServico.gnsCnae.replaceAll('-','').replaceAll('.','')

            axios.put(`/Telas/GarantePay/UpdateNotaServicos`, this.NotaServico)
            .then(response => {
                if (response.status == 200) {
                    this.$mensagemAvisoSucesso("Registro Alterado.")
                    this.NotaServico.gnsId= 0;
                    this.NotaServico.gnsCodigoServicoGarantePay = '';
                    this.NotaServico.gnsNomeServicoGarantePay = '';
                    this.NotaServico.gnsCodServicoFiscal = '';
                    this.NotaServico.gnsCodTributacao = '';
                    this.NotaServico.gnsCnae = '';
                    this.NotaServico.gnsIssTipoTributacao = null;
                    this.NotaServico.gnsIssExigibilidade = null;
                    this.NotaServico.gnsIssRetido = null;
                    this.NotaServico.gnsAliquota = '';
                    this.NotaServico.gnsPisAliquota = null;
                    this.NotaServico.gnsCofinsAliquota = null;
                    this.NotaServico.gnsCsllAliquota = null;
                    this.NotaServico.gnsInssAliquota = null;
                    this.NotaServico.gnsIrrfAliquota = null;
                    this.NotaServico.gnsOutrasRetencoes = null;
                    this.NotaServico.gnsCppAliquota = null;
                    this.NotaServico.gnsTributacaoTotalFederal = null;
                    this.NotaServico.gnsTributacaoTotalEstadual = null;
                    this.NotaServico.gnsTributacaoTotalMunicipal = null;

                    axios.get(`/Telas/GarantePay/GetAllNotaServicos`)
                    .then(response => {
                        this.GarantePayNotaServico = response.data;
                    });    
                }
            });
            }

        },
        DeleteServico(item){
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.gnsId;
                axios.delete(`/Telas/GarantePay/DeleteNotaServicos/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.NotaServico.gnsId= 0;
                    this.NotaServico.gnsCodigoServicoGarantePay = '';
                    this.NotaServico.gnsNomeServicoGarantePay = '';
                    this.NotaServico.gnsCodServicoFiscal = '';
                    this.NotaServico.gnsCodTributacao = '';
                    this.NotaServico.gnsCnae = '';
                    this.NotaServico.gnsIssTipoTributacao = null;
                    this.NotaServico.gnsIssExigibilidade = null;
                    this.NotaServico.gnsIssRetido = null;
                    this.NotaServico.gnsAliquota = '';
                    this.NotaServico.gnsPisAliquota = null;
                    this.NotaServico.gnsCofinsAliquota = null;
                    this.NotaServico.gnsCsllAliquota = null;
                    this.NotaServico.gnsInssAliquota = null;
                    this.NotaServico.gnsIrrfAliquota = null;
                    this.NotaServico.gnsOutrasRetencoes = null;
                    this.NotaServico.gnsCppAliquota = null;
                    this.NotaServico.gnsTributacaoTotalFederal = null;
                    this.NotaServico.gnsTributacaoTotalEstadual = null;
                    this.NotaServico.gnsTributacaoTotalMunicipal = null;


                    axios.get(`/Telas/GarantePay/GetAllNotaServicos`)
                    .then(response => {
                        this.GarantePayNotaServico = response.data;
                    });    
                    }
                });
            }
            });
        },
        EditCancel(){
            this.NotaServico.gnsId= 0;
                    this.NotaServico.gnsCodigoServicoGarantePay = '';
                    this.NotaServico.gnsNomeServicoGarantePay = '';
                    this.NotaServico.gnsCodServicoFiscal = '';
                    this.NotaServico.gnsCodTributacao = '';
                    this.NotaServico.gnsCnae = '';
                    this.NotaServico.gnsIssTipoTributacao = null;
                    this.NotaServico.gnsIssExigibilidade = null;
                    this.NotaServico.gnsIssRetido = null;
                    this.NotaServico.gnsAliquota = '';
                    this.NotaServico.gnsPisAliquota = null;
                    this.NotaServico.gnsCofinsAliquota = null;
                    this.NotaServico.gnsCsllAliquota = null;
                    this.NotaServico.gnsInssAliquota = null;
                    this.NotaServico.gnsIrrfAliquota = null;
                    this.NotaServico.gnsOutrasRetencoes = null;
                    this.NotaServico.gnsCppAliquota = null;
                    this.NotaServico.gnsTributacaoTotalFederal = null;
                    this.NotaServico.gnsTributacaoTotalEstadual = null;
                    this.NotaServico.gnsTributacaoTotalMunicipal = null;


                    axios.get(`/Telas/GarantePay/GetAllNotaServicos`)
                    .then(response => {
                        this.GarantePayNotaServico = response.data;
                    });    
        },
        Get() {
            axios.get(`/Telas/GarantePay/GetDados`)
               .then(response => {
                 this.GarantePay =response.data.admGarantePay;
                 this.GarantePayNota = response.data.admGarantePayNota;
                 this.GarantePayNotaServico = response.data.admGarantePayNotaServico;
         });
        }
    },
    created() {
        this.Get();
         
    },
    computed: {
        documentoMask() {
        return '##.###.###/####-##';
        }
   }
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
</style>
